var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotconnectInterpreterGirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 134 129",
    width: 134,
    height: 129,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "notconnect-interpreter-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #f54a4a } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m0.2 71.4q0-0.1-0.1-0.2c-0.4-12 0.1-16.1 11.3-19.8q0.4-0.1 0.6-0.5c8.6-25.7 24.5-40 48.9-40h0.1c25 0.9 42 13.1 48.8 40c0 0.4 0.2 0.4 0.6 0.5c8.2 2.4 12.5 7.1 11.7 15.2c-1.6 13.6-3.9 25.5-10.6 25.6q-0.4 0-0.7 0.2q-0.3 0.2-0.4 0.6c-3.1 11.1-10.6 21.9-22.6 30.7c-1 1.9-2.6 3.5-4.6 4.4c-2 0.9-4.2 1.1-6.3 0.7c-2.2-0.5-4.1-1.6-5.5-3.2c-1.4-1.7-2.2-3.7-2.2-5.8q-0.1-0.7 0.1-1.4c0.3-2.2 1.5-4.2 3.3-5.7c1.7-1.5 4-2.2 6.3-2.2c2.1 0 4.1 0.6 5.7 1.7q1 0.8 1.8 1.6c0.2 0.5 0.6 0.8 1.1 1.1c0.4 0.2 1 0.3 1.5 0.2q0.7-0.2 1.3-0.7c3.4-2.5 6.2-6 8.7-9.4c1.7-1.9 2.9-4.1 3.7-6.5c0.5-1.7-0.5-3.4-1.6-4.7c-1-1.2-5.9-5.8-7.5-3.6c-7.6 15.8-20.5 22-26.1 23.8c-20.2 3.4-34.4-13.6-39.2-20.6c-1.6-1.6-3.4-1.2-5.3-0.7c-1.9 0.7-3.9 1-5.9 0.9c-3.3 0.1-6.4-0.9-9.1-2.6c-5.7-4.1-7.1-13.1-7.8-19.4q0-0.1 0-0.2zm59.3 39.1c2.6 0.3 5.2 0 7.6-0.8c20.7-6.8 30-31 28.1-47.6q0-0.4-0.3-0.7q-0.3-0.2-0.8-0.2c-24.9 1-35.4-4.4-45-17.4q-0.2-0.3-0.5-0.4q-0.2-0.1-0.5 0q-0.3 0-0.6 0.2q-0.2 0.2-0.3 0.4c-3.7 9.8-10.3 15.6-19.7 17.1q0 0 0 0q-0.4 0-0.7 0.2q-0.2 0.3-0.2 0.7c-1.8 26.1 13.9 46.2 32.9 48.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m49.2 78.6c-1.2 1.1-2.8 1.8-4.5 1.8c-1.2 0-2.5-0.3-3.5-1c-1-0.7-1.9-1.6-2.3-2.8c-0.5-1.1-0.7-2.4-0.4-3.6c0.2-1.2 0.8-2.3 1.7-3.1c0.9-0.9 2.1-1.5 3.3-1.7c1.2-0.3 2.5-0.1 3.7 0.3c1.2 0.5 2.1 1.3 2.8 2.3c0.7 1 1.1 2.2 1.1 3.4c0 1.7-0.7 3.2-1.9 4.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m73.9 80.3c-1.7 0-3.3-0.6-4.5-1.8c-1.2-1.2-1.9-2.7-1.9-4.4c0-1.2 0.4-2.4 1.1-3.4c0.7-1 1.7-1.8 2.9-2.3c1.1-0.5 2.4-0.6 3.7-0.4c1.2 0.3 2.3 0.9 3.2 1.7c0.9 0.9 1.5 2 1.8 3.2c0.2 1.2 0.1 2.5-0.4 3.6c-0.5 1.1-1.3 2.1-2.3 2.8c-1.1 0.7-2.3 1-3.6 1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m53.6 100.2c-1.6-1.5-2.5-3.6-2.5-5.8h16.9c0 1.7-0.5 3.2-1.5 4.6c-0.9 1.4-2.2 2.4-3.7 3c-1.6 0.7-3.3 0.8-4.9 0.5c-1.7-0.3-3.2-1.1-4.3-2.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotconnectInterpreterGirl);
export default __webpack_public_path__ + "static/media/notconnect-interpreter-girl.c6374db20bb467886fb0b777991202b4.svg";
export { ForwardRef as ReactComponent };